import { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";

const RouteScrollReset = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") {
      return;
    }

    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;

    root.style.scrollBehavior = "auto";
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
    root.style.scrollBehavior = previousScrollBehavior;
  }, [location.pathname, location.search, navigationType]);

  return null;
};

const RootLayout = () => (
  <>
    <RouteScrollReset />
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

export default RootLayout;
